<div class="rm-header">
  <span>Create / Edit Direct Marketing Campaign</span>
</div>

<!-- <div class="row justify-content-center pt-3 pb-2">
  <div class="col-12">
    <span>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Laudantium dignissimos voluptatem odit, perferendis animi saepe corrupti harum exercitationem corporis! Dolorum?</span>
  </div>
</div> -->
<div class="row justify-content-center">
  <form [formGroup]="fg" style="display: flex; flex-direction: column; gap: 5px;">

  <div class="col-12 mt-2 mb-4">
    <h2>Current Live Deals</h2>
    <div class="deals-container">
      <mat-selection-list multiple formControlName="dealIds" style="width: 100%; max-height: 200px; overflow-y: auto;">
        <mat-list-option *ngFor="let deal of liveDeals$ | async" [value]="deal.id" color="primary" class="mb-2">
          <div style="display: flex; flex-direction: row; gap: 10px; align-items: center;">
            <img style="height: 50px" [src]="deal.dealImageUrl" alt="Deal Image" class="deal-image" />
            <span> {{deal.projectName}} </span>

          </div>
        </mat-list-option>
      </mat-selection-list>
    </div>
  </div>

  <div class="col-12 mt-2 mb-4">
    <h2>User Information</h2>
    <div>

    </div>
      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>User Email Address</mat-label>
        <input type="email" matInput placeholder="Enter email addresses" formControlName="email" />
        <mat-hint align="end">Enter the email address of the recipient</mat-hint>
      </mat-form-field>

      <mat-form-field appearance="outline" style="width: 100%;">
        <mat-label>Message to User</mat-label>
        <textarea matInput placeholder="Enter the message" formControlName="message" style="min-height: 50px;"></textarea>
        <mat-hint align="end">This will be the body of the email sent to the user</mat-hint>
      </mat-form-field>

  </div>
</form>

    <!-- <mat-form-field appearance="fill" class="form-field" style="width: 100%">
        <mat-label>Deals</mat-label>
        <mat-select multiple>
            <mat-option *ngFor="let deal of liveDeals$ | async" [value]="deal">
                {{deal.projectName}} | <em>{{deal.assetName}}</em>
            </mat-option>
        </mat-select>
    </mat-form-field> -->

    <!-- <div class="space-between mt-3">
        <h2>Add/Edit Target Persons</h2>
        <button mat-raised-button color="primary">Add New Target</button>
    </div>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="width: 100%">
        <ng-container matColumnDef="firstName">
            <th mat-header-cell *matHeaderCellDef> First Name </th>
            <td mat-cell *matCellDef="let element"> {{element.firstName}} </td>
        </ng-container>

        <ng-container matColumnDef="lastName">
            <th mat-header-cell *matHeaderCellDef> Last Name </th>
            <td mat-cell *matCellDef="let element"> {{element.lastName}} </td>
        </ng-container>

        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef> Email </th>
            <td mat-cell *matCellDef="let element"> {{element.email}} </td>
        </ng-container>

        <ng-container matColumnDef="company">
            <th mat-header-cell *matHeaderCellDef> Company </th>
            <td mat-cell *matCellDef="let element"> {{element.company}} </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Actions </th>
            <td mat-cell *matCellDef="let element"> 
                <button mat-icon-button color="warn"><mat-icon>delete</mat-icon></button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table> -->
   
</div>
<div class="space-between">
  <button mat-raised-button (click)="dialogRef.close()">Cancel</button>

  <span>
    <button mat-button color="primary" type="button" (click)="saveDraft()">Save Draft</button>
    &nbsp;
    <button mat-raised-button color="primary" type="button" (click)="sendEmail()" >Send Email to User</button>
  </span>
</div>
